<template>
  <div class="page">
    <iframe
      v-if="htmlContent"
      ref="iframeRef"
      :srcdoc="htmlContent"
      class="html-container"
      sandbox="allow-popups"
    />
  </div>
</template>

<script>
import featuramaApi from '../../../../api/Featurama.js';

export default {
  name: 'OtsResults',
  props: {},
  data() {
    return {
      insights: [],
    };
  },
  async created() {
    this.insights = await featuramaApi.getHtmlLlmInsights();
  },
  computed: {
    htmlContent() {
      return this.insights[0] && `
        <!DOCTYPE html>
        <html>
          <head>
            <style>
              body {
                margin: 0;
              }
              body > :first-child {
                padding-bottom: 80px !important;
              }
            </style>
          </head>
          <body>
            ${this.insights[0].html}
          </body>
        </html>
      `;
    },
  },

  methods: {
  },
};
</script>

<style lang="scss" scoped>
.page {
  height: 100%;
  > iframe {
    height: 100%;
    width: 100%;
    border: none;
  }
}
</style>
